<div
  [innerHTML]="_question() | displayMath"
  questionDisplayPlaceholder
  class="content ion-margin-bottom ion-padding-bottom"
></div>
